module.exports = __webpack_public_path__ + "static/media/step1.57e6dff4.png";